import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@blueprintjs/core';

const LabelComponent = ({ label }) => {
  const { t } = useTranslation();
  return (
    <Label
      style={{
        marginBottom: 0,
      }}
    >
      {t(label)}
    </Label>
  );
};

export default {
  name: 'Label',
  options: [
    {
      label: {
        label: 'Label',
        type: 'textbox',
        required: true,
      },
    },
  ],
  decorators: {
    label: false,
  },
  Component: LabelComponent,
};
